// Toggle for the spatial dataset preview (FileFullscreenPreview): map vs. the
// listing-only attribute table.
export enum PreviewViewMode {
  MAP = 'map',
  TABLE = 'table',
}
